enum TableTypeEnum {
    STANDARD = "standard",
    SMALL = "small",
    PHOTOS = "photos",
}

export default TableTypeEnum;
